define('MaxaPartPicker.Collection', [
    'SCCollection',
    'Eureka.MaxaPartPicker.MaxaPartPicker.SS2Model',
    'Utils'
], function (
    SCCollectionModule,
    MaxaPartPickerSS2Model,
    Utils
) {
    'use strict';

    var SCCollection = SCCollectionModule.SCCollection;

    function MaxaPartPickerCollection(models, options) {
        SCCollection.call(this, models, options);

        this.model = MaxaPartPickerSS2Model;
        this.url = function () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/MaxaPartPicker/SuiteScript2/MaxaPartPicker.Service.ss"
                ), true
            )
        }
    }

    MaxaPartPickerCollection.prototype = Object.create(SCCollection.prototype);
    MaxaPartPickerCollection.prototype.constructor = MaxaPartPickerCollection;

    return MaxaPartPickerCollection
})
